import React, { RefObject, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { Video } from 'expo-av';

import type { Tutorial } from '@models/Tutorials/TutorialModel';
import type { Course } from '@models/Courses/CourseModel';
import { TutorialDescription } from './TutorialDescription';
import { TutorialPlayer } from './TutorialPlayer';
import { Separator } from '@components';
import { CourseTitle } from './CourseTitle';

export interface IPlaylist {
  nextItem(currentId: number): Tutorial | null;
  previousItem(currentId: number): Tutorial | null;
}

export interface ITutorialContentProps {
  tutorial: Tutorial;
  course: Course | undefined;
  playlist: IPlaylist;
  onPressTimestamp(): void;
  videoPlayerRef: RefObject<Video>;
  fullScreenVideoPlayerRef: RefObject<Video>;
}

export const TutorialContent = observer<ITutorialContentProps>(
  ({
    tutorial,
    course,
    playlist,
    onPressTimestamp,
    videoPlayerRef,
    fullScreenVideoPlayerRef,
  }) => {
    const Header = useCallback(() => {
      return course ? (
        <React.Fragment>
          <CourseTitle course={course} tutorial={tutorial} />
          <Separator size={['$6', '$9']} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <TutorialDescription tutorial={tutorial} />
          <Separator size={['$5', '$10']} />
        </React.Fragment>
      );
    }, [course, tutorial]);

    return (
      <View>
        <Header />
        <TutorialPlayer
          tutorial={tutorial}
          course={course}
          playlist={playlist}
          onPressTimestamp={onPressTimestamp}
          videoPlayerRef={videoPlayerRef}
          fullScreenVideoPlayerRef={fullScreenVideoPlayerRef}
        />
      </View>
    );
  },
);
